export const localisable = {
  home: {
    welcomeTitle: "Welcome to Trade Insights",
    welcomeMessage:
      "Unleash the power of data-driven trading with our analysis dashboard.",
    loginButton: "Log In to Get Started",
  },
  error: {
    errorMissingEnvVariables: "Missing Auth0 environment variables",
    failedToFetch: "Failed to fetch data",
    authError: "useAuth must be used within an AuthProvider",
    errorLoading: "Error loading data",
  },
  loading: {
    checkingAuthentication: "Checking authentication...",
    loadingDashboard: "Loading dashboard data...",
    loadingData: "Loading data...",
  },
  dashboard: {
    unknownCountry: "Unknown Country",
    cumulativeTradeValue: "Cumulative Trade Value by Country",
    rankChanges: "Rank Changes Over Time",
    totalTrades: "Total Trades",
    averageTradeValue: "Average Trade Value",
    tradeData: "Trade Data",
    annualTradeValue: "Annual Trade Value Over Time",
    allCountries: "All Countries",
    topTradingPartners: "Top Trading Partners",
    logout: "Logout",
    dashboard: "Dashboard",
  },
};
